import React from 'react';
import { any, func, string } from 'prop-types';
import Radium from 'radium';
import { UTTextInput, UTButton, UTLabel, WithLoading } from '@widergy/energy-ui';

import AccountDebtTable from '../../../AccountHolderChange/components/AccountDebtTable';
import { accountDebtColumns } from '../../../AccountHolderChange/components/AccountDebtTable/constants';
import {
  getAccountDebtConcepts,
  getBillListTotalAmount
} from '../../../AccountHolderChange/accountHolderChangeHelper';
import { message } from '../../../../../../../utils/stringUtils';

import styles from './styles';

function TerminationRequestData({
  accountsData,
  onTerminationCancel,
  onTerminationSuccess,
  tempClientNumber,
  billList
}) {
  const currentAccount = accountsData.find(account => account.clientNumber === tempClientNumber);
  return (
    <div style={styles.container}>
      <div style={styles.titleContainer}>
        <UTLabel large extrabold style={styles.title}>
          {message('TerminationRequest:terminationRequest')}
        </UTLabel>

        <UTLabel style={styles.title}>{message('TerminationRequest:procedurePlaceholder')}</UTLabel>
      </div>

      <div style={styles.inputsContainer}>
        <UTTextInput
          input={{ name: 'supplyId', value: currentAccount && currentAccount.supplyId }}
          autoComplete={false}
          disabled
          style={styles.field}
          shouldDisplayErrors={false}
          label={message('AccountHolderChange:supply')}
          meta={{ active: false }}
        />

        <UTTextInput
          input={{ name: 'address', value: currentAccount && currentAccount.address }}
          autoComplete={false}
          disabled
          style={styles.field}
          shouldDisplayErrors={false}
          label={message('AccountHolderChange:supplyAddress')}
          meta={{ active: false }}
        />
      </div>

      <div style={styles.table}>
        <AccountDebtTable
          title={message('AccountHolderChange:clientDebt', { supply: tempClientNumber })}
          concepts={getAccountDebtConcepts(billList)}
          tableColumns={accountDebtColumns}
        />
        <UTLabel extrabold>
          {message('AccountHolderChange:userDebt', {
            debt: getBillListTotalAmount(billList)
          })}
        </UTLabel>
      </div>
      <div style={styles.infoText}>
        <UTLabel>{message('TerminationRequest:debtPlaceholder')}</UTLabel>
      </div>

      <div style={styles.infoText}>
        <UTLabel>{message('TerminationRequest:debtCancelPlaceholder')}</UTLabel>
      </div>

      <div style={styles.buttonsContainer}>
        <UTButton secondary style={styles.button} onPress={onTerminationCancel}>
          {message('TerminationRequest:cancel')}
        </UTButton>
        <UTButton style={styles.button} onPress={onTerminationSuccess}>
          {message('TerminationRequest:submit')}
        </UTButton>
      </div>
    </div>
  );
}

TerminationRequestData.propTypes = {
  accountsData: any, // eslint-disable-line
  onTerminationCancel: func.isRequired,
  onTerminationSuccess: func.isRequired,
  tempClientNumber: string,
  billList: any // eslint-disable-line
};

export default WithLoading(props => props.loading)(Radium(TerminationRequestData));
